<template>
  <div class="auth-modal">
    <div
      class="modal fade"
      id="sendPostSMSModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="sendPostSMSModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header pb-0 border-0">
            <div>
              <h5 class="title my-0">Send SMS</h5>
              <small class="text-muted">Send post as SMS to circle members</small>
            </div>
          </div>
          <div class="modal-body pt-3">
            <div class="row justify-content-center" v-if="members">
              <div class="col-12 mb-3">
                <div class="table-responsive" style="max-height: 500px">
                  <table class="table table-sm table-borderless">
                    <thead>
                      <tr style="border-bottom: 1px solid lightgray;">
                        <th class="d-flex align-items-center justify-content-start">
                          <input
                            :checked="selectAll"
                            @input="toggleSelectAllMembers()"
                            type="checkbox"
                            class="form-control form-control-sm mr-3"
                          />
                          <span>User</span>
                        </th>
                        <th>Role</th>
                        <th>Joined</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="member in filteredMembers"
                        :key="member._id"
                        :class="{'bg-dark text-light':isSelected(member)}"
                      >
                        <td class="d-flex align-items-center justify-content-start">
                          <input
                            @input="toggleSelectOne(member)"
                            :checked="isSelected(member)"
                            type="checkbox"
                            :id="`sms-member-${member._id}`"
                            class="form-control form-control-sm mr-3"
                          />
                          <label
                            class="d-flex align-items-center justify-content-start"
                            :for="`sms-member-${member._id}`"
                          >
                            <div>
                              <img
                                v-if="member.profile.upload && member.profile.upload.path"
                                class="rounded-circle"
                                width="32"
                                height="32"
                                :src="member.profile.upload.path"
                                alt
                              />
                              <img
                                v-else
                                class="rounded-circle"
                                width="32"
                                height="32"
                                src="../../../assets/avatar.png"
                              />
                            </div>
                            <div
                              class="ml-2 d-flex align-items-center justify-content-start flex-column"
                            >
                              <span
                                class="content-header__name"
                                :class="{'text-light':isSelected(member)}"
                              >{{ member.profile.name }}</span>
                              <small class="text-muted">{{getContact(member.profile)}}</small>
                            </div>
                          </label>
                        </td>
                        <td>
                          <span class="content-header__name text-capitalize">{{ getRole(member) }}</span>
                        </td>
                        <td>
                          <span class="content-header__name">{{ getDateJoined(member) }}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <table class="table table-sm table-borderless" v-if="audience && audience.length">
                    <thead>
                      <tr style="border-bottom: 1px solid lightgray;">
                        <th class="d-flex align-items-center justify-content-start">
                          <span>Audience</span>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="single in audience"
                        :key="single._id"
                        :class="{'bg-dark text-light':isAudienceSelected(single)}"
                      >
                        <td class="d-flex">
                          <input
                            @input="toggleAudienceSelect(single)"
                            :checked="isAudienceSelected(single)"
                            type="checkbox"
                            :id="`single-audience-${single._id}`"
                            class="form-control form-control-sm mr-3"
                          />
                          <span
                            class="content-header__name text-truncated"
                            :class="{'text-light':isAudienceSelected(single)}"
                          >{{ single.description }}</span>
                        </td>
                        <td class="d-flex justify-content-start">
                          <label
                            class="d-flex align-items-start"
                            :for="`single-audience-${single._id}`"
                          >
                            <div>
                              <i class="fa fa-people fa-2x"></i>
                            </div>
                            <div
                              class="ml-2 d-flex align-items-center justify-content-start flex-column"
                            >
                              <small class="text-muted text-truncated flex-wrap: wrap">{{single.body}}</small>
                            </div>
                          </label>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div v-else>
                    No audience found. Add new contacts to the box below and save as new audience.
                  </div>
                </div>

                <div class="form-group pt-4">
                  <small class="text-muted">
                    Do you have any persons that are not in this circle but you want to send this post to?
                    <br />Enter their phone numbers below like this: +2348156412890, +23480338940...
                  </small>
                  <textarea
                    v-model="otherNumbers"
                    rows="2"
                    class="form-control form-control-lg w-100 my-3"
                  ></textarea>
                </div>
                <div class="form-group pb-3" v-if="saveAudience && otherNumbers">
                  <label><small>Audience title</small></label>
                  <input type="text" class="form-control" v-model="audienceDescription">
                  <small class="text-danger" v-show="audienceDescription===''">Describe your new audience</small>
                </div>
                <div class="form-group" v-if="otherNumbers">
                  <label>
                    <input type="checkbox" :checked="saveAudience" v-model="saveAudience"/>&nbsp;<small class="text-muted">Save as new audience</small>
                  </label>
                </div>

                <div
                  class="mt-3 d-flex align-items-center justify-content-end"
                  style="flex-wrap: wrap"
                >
                  <button
                    id="dismissBtnSendPostSMS"
                    @click="resetForm()"
                    data-dismiss="modal"
                    class="btn btn-light mr-2 my-1 btn-sm"
                  >Cancel</button>
                  <button
                    :disabled="!formValid"
                    id="joinCircleBtn"
                    @click="sendSMS($event)"
                    class="btn btn-primary my-1 btn-sm"
                  >Send SMS</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContentService from "@/services/content";
import swal from "sweetalert";

const contentService = new ContentService();

export default {
  name: "SendPostSMS",
  props: ["members", "post", "circle", "user", "audience_list"],
  data() {
    return {
      memberList: [],
      selectedMembers: [],
      otherNumbers: "",
      selectAll: false,
      audience: [],
      selectedAudience: [],
      saveAudience: false,
      audienceDescription: ''
    };
  },
  methods: {
    getContact(profile) {
      let contact = "";

      if (profile.phone[0] === "+") {
        contact = profile.phone;
      } else if (
        profile.email &&
        !profile.email.includes("@fauxinfodemics.com")
      ) {
        contact = profile.email;
      }

      return contact;
    },
    getRole(member) {
      let role = "";

      if (member.type === "role") {
        if (member.status === "default") {
          role = "member";
        } else {
          role = member.status;
        }
      }
      return role;
    },
    getDateJoined(member) {
      const months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
      ];

      const d = new Date(member.created * 1000),
        yyyy = d.getUTCFullYear(),
        mm = d.getUTCMonth(),
        dd = d.getUTCDate();
      let date,
        m = months[mm],
        ddd = `${dd}`;

      if (dd < 10) {
        ddd = `0${dd}`;
      }

      return `${ddd} ${m} ${yyyy}`;
    },
    submit(e) {
      const closeBtn = document.getElementById("addMemberDismissBtn");
      const btn = e.srcElement;

      btn.disabled = true;
      btn.innerText = "Processing";
      btn.classList.add("btn--loading");
    },
    toggleSelectAllMembers() {
      this.selectAll = !this.selectAll;

      if (this.selectAll) {
        this.selectedMembers = Array.from(
          new Set(this.filteredMembers.map(s => s.profile.phone))
        );
      } else {
        this.selectedMembers = [];
      }
    },
    isSelected(member) {
      return this.selectedMembers.find(s => s === member.profile.phone);
    },
    isAudienceSelected(audience) {
      return this.selectedAudience.find(s => s._id === audience._id);
    },
    toggleSelectOne(member) {
      this.selectAll = false;
      const phoneIndex = this.selectedMembers.findIndex(
        s => s === member.profile.phone
      );

      if (phoneIndex > -1) {
        this.selectedMembers.splice(phoneIndex, 1);
      } else {
        this.selectedMembers.push(member.profile.phone);
      }

      if (this.selectedMembers.length === this.filteredMembers.length) {
        this.selectAll = true;
      }
    },
    toggleAudienceSelect(audience) {
      // this.selectAll = false;
      const audienceIndex = this.selectedAudience.findIndex(
        s => s._id === audience._id
      );

      if (audienceIndex > -1) {
        this.selectedAudience.splice(audienceIndex, 1);
      } else {
        this.selectedAudience.push(audience);
      }

    },
    resetForm() {
      (this.selectedMembers = []),
        (this.otherNumbers = ""),
        (this.selectAll = false),
        (this.selectedAudience = []);
    },
    sendSMS(e) {
      const submitBtn = e.srcElement;

      swal({ text: `Send post as SMS?`, icon: "warning", buttons: true }).then(
        willSendSMS => {
          if (willSendSMS) {
            const defaultBtnText = submitBtn.innerText;

            submitBtn.classList.add("btn--loading");
            submitBtn.disabled = true;
            submitBtn.innerText = "Processing";

            let audi = this.selectedAudience
            let recipient = this.allNumbers + `${audi.length && this.allNumbers !== '' ? ',' : ''}${audi.map(item => item.body).join()}`

            if(this.saveAudience) {
              let new_audience = {
                description: this.audienceDescription,
                body: this.otherNumbers,
                type: 'sms',
                circle_id: this.$props.circle._id,
                profile_id: this.$props.user._id 
              }
              contentService.createCircleAudience(new_audience)
                .then(res => {
                  console.log(res)
                  this.$root.$emit('CreateAudience', new_audience)
                })
                .catch( err => {
                  console.log(err)
                })
            }

            const obj = {
              recipient,
              message: this.$props.post
            };

            contentService
              .sendPostAsSMS(obj)
              .then(() => {
                submitBtn.classList.remove("btn--loading");
                submitBtn.disabled = false;
                submitBtn.innerText = defaultBtnText;

                document.getElementById("dismissBtnSendPostSMS").click();
                this.$notification.new(`Post has been sent as an SMS`);
              })
              .catch(err => {
                submitBtn.classList.remove("btn--loading");
                submitBtn.disabled = false;
                submitBtn.innerText = defaultBtnText;
                this.$root.$emit("ShowErrorNotification", err.message);
              });
          }
        }
      );
    }
  },
  computed: {
    filteredMembers: function() {
      return this.memberList.filter(s => s.profile.phone[0] === "+");
    },
    formValid: function() {
      return this.selectedMembers.length 
        || (this.otherNumbers && (
            (this.saveAudience && this.audienceDescription !== '') 
            || !this.saveAudience)
          ) 
        || this.selectedAudience.length;
    },
    allNumbers: function() {
      return `${this.selectedMembers.join()}${
        this.selectedMembers.length && this.otherNumbers ? "," : ""
      }${`${this.otherNumbers ? `${this.otherNumbers}` : ""}`}`;
    }
  },
  watch: {
    "$props.members": {
      handler: function(val) {
        this.memberList = val ? val : [];
      },
      deep: true,
      immediate: true
    },
    "$props.audience_list": {
      handler: function (val) {
        this.audience = val ? val : []
      },
      deep: true,
      immediate: true,
    }
  }
};
</script>

<style scoped lang="scss">
    tr:not(:last-of-type) {
        border-bottom: 1px solid lightgray;
    }

    .btn-shell {
        background: none;
        border: none;
        height: auto;
        width:auto;
        margin: 0;
        padding: 0;
        outline: none;
        cursor: pointer;
    }

    .form-group {
        margin: 0 !important;
    }

    th {
        position: sticky;
        top: 0;
        background: white !important;
    }

    input[type="checkbox"] {
        margin-top: 1px;
    }
</style>
<style scoped lang="scss" src="../../Auth/AuthModal/AuthModal.scss"></style>